import { combineReducers } from 'redux'
import amenity from 'states/dux/amenity'
import amenityBooking from 'states/dux/amenity-booking'
import document from 'states/dux/document'
import documentAdmin from 'states/dux/document-admin'
import incidentReport from 'states/dux/incident-report'
import layout from 'states/dux/layout'
import message from 'states/dux/message'
import news from 'states/dux/nivos-news'
import nivosPost from 'states/dux/nivos-post'
import theme from 'states/dux/theme'
import user from 'states/dux/user'
import userAdmin from 'states/dux/user-admin'

const reducer = (): any =>
  combineReducers({
    theme,
    layout,
    incidentReport,
    amenityBooking,
    amenity,
    user,
    document,
    nivosPost,
    news,
    userAdmin,
    documentAdmin,
    message
  })

export { reducer }

export default reducer
